import { TagMemberType } from '@design-system/components/molecules/tag-member/entities/tag-member.types';

export enum PriceDetailCardType {
  Tooltip = 'tooltip',
  Embedded = 'embedded',
}

export interface PriceDetailCardSubtitle {
  Label: string;
  Description: string;
}

export enum PriceDetailCardDiscountStyle {
  Pro = 'pro',
  Rappi = 'rappi',
  Pay = 'pay',
  Default = 'default'
}

export interface PriceDetailCardDiscount {
  Label: string;
  Amount: string;
  UseTagStyle: boolean;
  TagMemberLabel: string;
  TagMemberType: TagMemberType;
}

export interface PriceDetailCardPrice {
  Label: string;
  Amount: string;
  Disabled?: boolean;
  Info?: string;
}
